<template>
  <b-modal
      id="plan-history-modal"
      size="xl"
      v-model="showPlanHistoryModal"
      @hide="closeModal"
      hide-footer
      hide-header-close
  >
    <b-button variant="close-btn" class='btn-container' @click="closeModal">
      <i class="fas fa-times"></i>
    </b-button>
    <div class="platform-title-text text-center mt-3 mb-3">
      <h5><strong>View Plan History </strong></h5>
      <div class="plan-history-data-wrap mt-3">
        <div class="table-responsive">
          <table class="table">
            <thead>
            <tr>
              <th>Plan Name</th>
              <th>Carrier</th>
              <th>Dates</th>
              <th>Premium Amounts</th>
              <th>Plan Status</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td v-if="!member.plan_history.length" colspan="6" align="center">
                No records found.
              </td>
            </tr>
            <tr
                :id="index"
                v-for="(item, index) in member.plan_history"
                :class="{ termed: item.status.toLowerCase() === 'termed' }"
                :key="index"
            >
              <td>{{item.plan_name}} / {{item.tier}}</td>
              <td>{{item.carrier_name}}</td>
              <td style="text-align: left">
                <div>
                  <strong>Effective Date:</strong>
                  {{item.plan_effective_date}}  <br />
                </div>
                <div>
                  <strong>Termination Date:</strong>
                  {{item.plan_term_date}}  <br />
                </div>
              </td>
              <td> ${{item.price}}</td>
              <td>
                {{item.status}}
                <div class="mt-1">
                  <button
                      v-if="canActivate(item.status,item.plan_term_date ? item.plan_term_date :null, item.is_assoc, member.is_plan_available)"
                      @click="showActivateFormModel(item)"
                      class="btn-activate"
                      v-b-tooltip.hover title="Re-Activate"
                  >
                    <img src="../../../assets/img/re-activate.svg" alt="" class="reactive">
                    <span class="reactive-txt ml-1">Re-activate</span>
                  </button>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";

export default {
  name: "MemberPlanHistoryModal",
  props: {
    member: {
      required: true,
    },
    showPlanHistoryModal: {
      type: Boolean,
      required: true
    },
    plan: {
      type: Object,
    }
  },
  data () {
    return {
      isFlagRender: false
    }
  },
  methods: {
    closeModal() {
      this.$emit("update:showPlanHistoryModal", false);
      this.$emit("onClosedModal");
    },
    showActivateFormModel (item) {
      let planInfo = {}
      planInfo['plans'] = item
      planInfo['planPolicyId'] = this.member.policy_id
      this.$emit('showActivateModel', planInfo)
    },
    canActivate(status,date,isAssoc, is_plan_available){
      let activeStatus = false;
      if(status == 'WITHDRAWN'){
        activeStatus =  true
      }else if(status != 'ACTIVE' && date){
        let todayDate=moment(new Date()).format('MM/DD/YYYY');
        activeStatus = moment(date).isBefore(todayDate)
      }else{
        activeStatus =  false;
      }
      return activeStatus && (!isAssoc) && is_plan_available
    },
  }
}
</script>

<style src="@/assets/css/member-plan-history.css"></style>